import Service from "@/utils/api/service";
import Media from "@/components/share/media";
import TableLoading from "@/components/share/table-loading";
import _debounce from "lodash.debounce";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "EditNotification",
  props: {},
  data() {
    return {
      isUpdating: false,
      isFetching: true,
      display: {
        imagePreview: false,
        media: false,
        schedule: false,
      },
      body: {
        imageUrl: "",
        title: "",
        description: "",
        pushAt: "",
        customerIds: "",
        customerGroupIds: "",
      },
      data: {
        notificationDetail: "",
        media: "",
      },
      models: {
        time: "",
        date: "",
      },
      customToolbarSpecification: [
        ["bold", "italic", "underline"],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
        ["link"],
      ],
      customers: [],
      customerGroups: this.$master?.customerGroups || [],
      allCustomerGroups: this.$master?.customerGroups || [],
      loading: {
        isCreating: false,
        isSearching: false,
      },
      isAbleUpdate: true,
    };
  },
  components: {
    Media,
    TableLoading,
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
    debouncedOnSearchCustomers() {
      return _debounce(this.searchCustomers, 500);
    },
    debouncedOnSearchCustomerGroups() {
      return _debounce(this.searchCustomerGroups, 500);
    },
    customerOptions() {
      return this.customers.map((c) => ({
        ...c,
        displayName: c.bpName
          ? c.bpName
          : !c.firstName && !c.lastName && c.bpName
          ? c.bpName
          : `${c.firstName || ""} ${c.lastName || ""}`.trim(),
      }));
    },
    customerGroupOptions() {
      return this.customerGroups.map((c) => ({
        ...c,
        displayName: `${c.name || ""}`.trim(),
      }));
    },
    isFutureDate() {
      if (!this.models.date) return false;
      const selected = new Date(this.models.date);
      const now = new Date();
      return selected > now;
    },
  },
  created() {
    setTimeout(() => {
      // this.searchCustomers();
      this.searchCustomerGroups();
    }, 500);

    this.getNotification();
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListNotification",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    // customer group change
    onCustomerGroupSelect() {
      this.searchCustomers();
      // return selectedOption;
    },

    onCustomerGroupRemove(removedGroup) {
      this.onAutoRemoveCustomerByCustomerGroupId(removedGroup);

      if (this.body.customerGroupIds && !this.body.customerGroupIds.length) {
        this.body.customerIds = [];
      }
    },

    onAutoRemoveCustomerByCustomerGroupId(removedGroup) {
      if (this.body.customerIds && this.body.customerIds.length) {
        const updatedCustomerIds = this.body.customerIds.filter(
          (item) => item?.customerGroupId !== removedGroup?.id
        );

        this.body.customerIds = updatedCustomerIds;
      }

      this.searchCustomers();
    },

    // search
    async searchCustomers(query) {
      if (!this.checkoutPermission("LIST_CUSTOMER_ACCOUNT")) return;

      this.loading.isSearching = true;
      let search = { search: query };

      // Build initial query object — WITHOUT `page`
      let setQuery = {
        limit: 10,
        offset: 0,
        status: "active",
        customerGroupIds: this.body.customerGroupIds?.map((group) => group.id),
        ...search,
      };

      // Filter out empty/null/undefined values and empty arrays
      let cleanQuery = Object.entries(setQuery).reduce((acc, [key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          (!Array.isArray(value) || value.length > 0)
        ) {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Build query string manually
      let queryParts = [];

      // Handle array params like customerGroupIds
      Object.entries(cleanQuery).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => {
            queryParts.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
            );
          });
        } else {
          queryParts.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          );
        }
      });

      let params = queryParts.join("&");

      await Service.getCustomers(`?${params}`).then((response) => {
        this.loading.isSearching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.searchCustomers();
              }
            });
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          this.customers = response?.data;
        }
      });
    },

    searchCustomerGroups(query) {
      if (!query || query.trim() === "") {
        this.customerGroups = [...this.allCustomerGroups];
        return;
      }

      this.filterCustomerGroup(this.allCustomerGroups, query);
    },

    filterCustomerGroup(data, search) {
      if (!search || search.trim() === "") {
        this.customerGroups = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.customerGroups = items;
    },

    getNotification() {
      Service.getNotificationDetail(this.$route.query.id).then((response) => {
        this.isFetching = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getNotification();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.notificationDetail = response.data;
          this.body = {
            imageUrl: response.data.imageUrl,
            title: response.data.title,
            description: response.data.description,
            status: response.data.status,
            pushAt: response.data.pushAt,
            customerIds: response.data?.customerIds || [],
            customerGroupIds: response.data?.customerGroupIds || [],
          };

          if (
            response?.data?.customerGroups &&
            response?.data?.customerGroups.length
          ) {
            this.body.customerGroupIds = response?.data?.customerGroups.map(
              (c) => ({
                ...c,
                displayName: `${c?.name || ""}`.trim(),
              })
            );
          }

          if (response?.data?.customers && response?.data?.customers.length) {
            this.body.customerIds = response?.data?.customers.map((c) => ({
              ...c,
              displayName: c?.bpName
                ? c?.bpName
                : !c?.firstName && !c?.lastName && c?.bpName
                ? c?.bpName
                : `${c?.firstName || ""} ${c?.lastName || ""}`.trim(),
            }));
          }

          if (response.data.imageUrl) {
            this.data.media = {
              fileName: this.getNameFromUrl(response.data.imageUrl),
              url: response.data.imageUrl,
            };
          }
          if (response.data.type == "schedule") {
            this.display.schedule = true;
            this.models.date = new Date(response.data.pushAt)
              .toISOString()
              .slice(0, 16);
          }

          this.isAbleUpdate = this.isEditFunc(response?.data);
        }
      });
    },
    timestampFormat(date, delimiter) {
      let hours = date.getHours();
      const minutes = ("00" + date.getMinutes()).slice(-2);
      hours = (date.getHours() - 7) % 12;
      hours = ("00" + hours).slice(-2);
      let time = hours.toString();

      const timestamp = [time.replace("-", "0"), minutes].join(
        delimiter || ":"
      );
      return [timestamp].join(" ");
    },
    removeMedia() {
      this.data.media = "";
      this.body.imageUrl = "";
    },
    closeModal() {
      this.display = {
        imagePreview: false,
        media: false,
      };
    },

    imagePreview() {
      if (this.body.imageUrl) {
        this.display.imagePreview = true;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getNameFromUrl(url) {
      return url.split("/").pop();
    },

    chooseImage() {
      this.display.media = true;
    },

    existedMediaCallback(media) {
      this.data.media = media;
      this.body.imageUrl = media.url;
      this.closeModal();
    },

    fileToPath(file) {
      return window.URL.createObjectURL(file);
    },

    confirmUpdate() {
      if (this.data.notificationDetail.type == "instant") {
        let validatedMessage = this.validateBody(this.body);
        if (validatedMessage == "ok") {
          this.isUpdating = true;
          this.updateNotification();
        } else {
          this.$toasted.show(validatedMessage);
        }
      } else {
        let validatedMessage = this.validateScheduleBody(this.body);
        if (validatedMessage == "ok") {
          this.isUpdating = true;
          this.updateNotificationSchedule();
        } else {
          this.$toasted.show(validatedMessage);
        }
      }
    },

    isEditFunc(data) {
      const pad = (n) => n.toString().padStart(2, "0");
      const now = new Date();
      const localISO = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
        now.getDate()
      )}T${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
        now.getSeconds()
      )}.000Z`;

      const pushAt = new Date(data?.pushAt);

      if (isNaN(pushAt.getTime())) {
        return false;
      }

      if (data?.pushAt < localISO) {
        return false;
      }

      return true;
    },

    validateScheduleBody(data) {
      if (!data.title) {
        return "Title cannot be empty!";
      } else if (!this.models.date) {
        return "Date cannot be empty!";
      } else if (!data.description) {
        return "Description cannot be empty!";
      } else {
        return "ok";
      }
    },

    validateBody(data) {
      if (!data.title) {
        return "Title cannot be empty!";
      } else if (!data.description) {
        return "Description cannot be empty!";
      } else {
        return "ok";
      }
    },

    updateNotification() {
      delete this.body.pushAt;
      Service.updateNotification(
        this.$route.query.id,
        this.isAbleUpdate
          ? this.body
          : {
              status: this.body.status,
              imageUrl: this.body.imageUrl,
              description: this.body.description,
              title: this.body.title,
            }
      ).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.updateNotification();
              }
            });
          } else {
            this.isUpdating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isUpdating = false;
          this.goBack();
          this.$toasted.show("Notification has been updated.");
        }
      });
    },
    updateNotificationSchedule() {
      this.body.pushAt = this.models.date + ":00.000Z";

      if (this.isAbleUpdate) {
        Service.updateNotificationSchedule(
          this.$route.query.id,
          this.isAbleUpdate
            ? this.body
            : {
                status: this.body.status,
                imageUrl: this.body.imageUrl,
                description: this.body.description,
                title: this.body.title,
              }
        ).then((response) => {
          if (response.statusCode) {
            if (response.statusCode == "4410") {
              Service.refreshToken().then((response) => {
                if (response == "ok") {
                  this.updateNotificationSchedule();
                }
              });
            } else {
              this.isUpdating = false;
              this.$toasted.show(response.message);
            }
          } else {
            this.isUpdating = false;
            this.goBack();
            this.$toasted.show("Notification has been updated.");
          }
        });
      } else {
        Service.updateNotification(this.$route.query.id, {
          status: this.body.status,
          imageUrl: this.body.imageUrl,
          description: this.body.description,
          title: this.body.title,
        }).then((response) => {
          if (response.statusCode) {
            if (response.statusCode == "4410") {
              Service.refreshToken().then((response) => {
                if (response == "ok") {
                  this.updateNotificationSchedule();
                }
              });
            } else {
              this.isUpdating = false;
              this.$toasted.show(response.message);
            }
          } else {
            this.isUpdating = false;
            this.goBack();
            this.$toasted.show("Notification has been updated.");
          }
        });
      }
    },
  },
};
